module.exports = __webpack_public_path__ + "static/img/edge_img_1.12e80b54.png";